export default __webpack_public_path__ + "static/media/mysql.c48ab2a4.svg";